import { Dispatch } from 'redux';

import { addGlobalError, stopLoader } from 'containers/App/actions';

const handleError = (dispatch: Dispatch) => {
  dispatch(addGlobalError());
  dispatch(stopLoader());

  document.body.scrollTop = 0;
};

export default handleError;
